'use client'
import { Button, ButtonProps } from '@/shared/ui/button'
import { CountdownStoreProps, useCountdownStore } from '../model'
import { Timer } from 'lucide-react'
import { cn } from '@/shared/lib/classnames'
import { formatTime } from '../lib'
import { useEffect } from 'react'

export interface CountdownButtonProps extends ButtonProps {
  timer?: number
  slots?: {
    textContent?: (v: CountdownStoreProps) => React.ReactNode
  }
}

export default function CountdownButton({
  timer: timerProp,
  children,
  className,
  slots,
  ...props
}: CountdownButtonProps) {
  const countdownStore = useCountdownStore()

  useEffect(() => {
    countdownStore.startCountdown()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Button
      size="lg"
      variant="defaultGhost"
      className={cn('flex gap-4 items-center', className)}
      disabled={countdownStore.seconds > 0}
      {...props}
      onClick={(e) => {
        countdownStore.startCountdown()
        props.onClick && props.onClick(e)
      }}
    >
      <div>{slots?.textContent ? slots?.textContent(countdownStore) : children}</div>
      <div className="flex items-center justify-center gap-1">
        <Timer size="16" />
        <div className="mt-px">{`00:${formatTime({
          seconds: countdownStore.seconds,
        })}`}</div>
      </div>
    </Button>
  )
}
